import React, { useState, useEffect } from 'react';
import { gameAPI } from '../api';

const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLeaderboard = async () => {
    try {
      const res = await gameAPI.getLeaderboard();
      setLeaderboard(res.data);
    } catch (err) {
      console.error('获取排行榜失败', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: '20px' }}>加载排行榜中...</div>;

  return (
    <div className="card" style={{ marginTop: '30px', padding: '20px' }}>
      <h3 style={{ marginTop: 0 }}>🏆 最高分排行榜</h3>
      {leaderboard.length === 0 ? (
        <p>暂无数据，快去创造高分吧！</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid var(--color-border-primary)' }}>
              <th style={{ padding: '8px', textAlign: 'left' }}>排名</th>
              <th style={{ padding: '8px', textAlign: 'left' }}>玩家</th>
              <th style={{ padding: '8px', textAlign: 'right' }}>最高分</th>
            </tr>
          </thead>
          <tbody>
            {leaderboard.map((user, idx) => (
              <tr key={idx} style={{ borderBottom: '1px solid var(--color-border-primary)' }}>
                <td style={{ padding: '8px' }}>{idx + 1}</td>
                <td style={{ padding: '8px' }}>{user.username}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{user.high_score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Leaderboard;